import { render, staticRenderFns } from "./ProductGalleryList.vue?vue&type=template&id=cfc1dffa&scoped=true&"
import script from "./ProductGalleryList.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryList.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryList.vue?vue&type=style&index=0&id=cfc1dffa&lang=scss&scoped=true&"
import style1 from "./ProductGalleryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc1dffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VIcon,VImg,VListItem,VRating,VRow})
